import client from '../client'
import { HolidayItem } from 'utils/common/calendar'

export async function getHolidayCalendar(): Promise<HolidayItem[]> {
  const response = await client.get<HolidayItem[]>(`/service-api/v1/calendar/holiday`)

  return response.data
}
